import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ApAlertService } from 'webcommon/core-ui';
import { FcIndustryListItemDto, FcModifyIndustryListItemDto } from 'webcommon/shared';
import { FcGenericItemModalBaseComponent, FcListValidationService } from '../../generic';

@Component({
  providers: [ApAlertService, FcListValidationService],
  selector: 'fc-industry-list-modal',
  templateUrl: './fc-industry-list-modal.component.html',
})
export class FcIndustryListModalComponent extends FcGenericItemModalBaseComponent implements OnInit {
  public override baseId = 'fc-industry-item';

  // List Item with default value
  public listItem: FcIndustryListItemDto = {
    Id: '',
    ExternalID: '',
    IndustryCode: '',
    IndustryUid: '',
    Name: '',
    Notes: '',
    Inactive: false,
    UserDefined: true,
  };

  // Form Controls
  public externalIdControl: FormControl = new FormControl('');
  public industryCodeControl: FormControl = new FormControl('');
  public industryUidControl: FormControl = new FormControl('');
  public nameControl: FormControl = new FormControl('');
  public notesControl: FormControl = new FormControl('');
  public inactiveControl: FormControl = new FormControl(false);
  public userDefinedControl: FormControl = new FormControl(true);

  // Form Group
  public form = new FormGroup({
    externalId: this.externalIdControl,
    industryCode: this.industryCodeControl,
    industryUid: this.industryUidControl,
    name: this.nameControl,
    notes: this.notesControl,
    inactive: this.inactiveControl,
    userDefined: this.userDefinedControl,
  });

  override ngOnInit() {
    super.ngOnInit();

    // Load List Item and set default validation rules
    this.loadListItem({
      ExternalID: {
        MaxLength: 25,
      },
      Name: {
        IsRequired: true,
        MaxLength: 65535,
      },
      IndustryCode: {
        MaxLength: 10,
      },
      Notes: {
        MaxLength: 65535,
      },
    });
  }

  public setForm(): void {
    // External Id Control
    this.externalIdControl.setValidators(this.fcListValidation.getValidators('ExternalID'));
    this.externalIdControl.setValue(this.listItem.ExternalID);

    // Industry Code Control
    this.industryCodeControl.setValidators(this.fcListValidation.getValidators('IndustryCode'));
    this.industryCodeControl.setValue(this.listItem.IndustryCode);

    // Name Control
    const isNameControlDisabled = !this.listItem.UserDefined;
    if (isNameControlDisabled) {
      this.nameControl.disable();
    }
    this.nameControl.setValidators(this.fcListValidation.getValidators('Name'));
    this.nameControl.setValue(this.listItem.Name);

    // Notes Control
    this.notesControl.setValidators(this.fcListValidation.getValidators('Notes'));
    this.notesControl.setValue(this.listItem.Notes);

    // Inactive Control
    this.inactiveControl.setValue(this.listItem.Inactive);

    // User Defined Control
    this.userDefinedControl.disable();
    this.userDefinedControl.setValue(this.listItem.UserDefined);

    this.validateForm();
  }

  public override save(): void {
    const values = this.form.getRawValue();
    const modifyItemDto: FcModifyIndustryListItemDto = {
      ExternalID: values.externalId,
      IndustryCode: values.industryCode,
      Name: values.name,
      Notes: values.notes,
      Inactive: values.inactive,
      UserDefined: values.userDefined,
    };
    super.save<FcModifyIndustryListItemDto>(modifyItemDto);
  }
}
